/**
 * Where the reference list starts.
 *
 * A heading line that says only "References", "Reference List", "Works Cited",
 * "Bibliography" (or one of their close variants), optionally numbered ("7. References")
 * or followed by a colon. The LAST such line wins, so a table of contents that lists
 * "References" near the top does not swallow the whole paper.
 */

const REFERENCE_HEADING_RE =
  /^[ \t]*(?:(?:\d{1,2}(?:\.\d{1,2})*|[IVXLC]{1,6})\.?[ \t]+)?(references|reference list|works cited|works consulted|bibliography|literature cited|sources cited)[ \t]*:?[ \t\r]*$/gim;

export interface ReferenceListStart {
  /** Offset of the heading line — the reference list runs from here to the end. */
  start: number;
  /** The heading as written, e.g. "Works Cited". */
  heading: string;
}

export function findReferenceList(text: string): ReferenceListStart | null {
  let last: RegExpMatchArray | null = null;
  for (const match of text.matchAll(REFERENCE_HEADING_RE)) {
    last = match;
  }
  if (!last || last.index === undefined) {
    return null;
  }
  return { start: last.index, heading: last[1] };
}
